import { PrivilegesActionTypes, SetPrivileges, ClearPrivileges } from './ActionTypes';
import { IPrivileges } from 'Store/IPrivileges';

export const setPrivileges = (privileges: IPrivileges): SetPrivileges => ({
    type: PrivilegesActionTypes.Set as PrivilegesActionTypes.Set,
    privileges
});

export const clearPrivileges = (): ClearPrivileges => ({
    type: PrivilegesActionTypes.Clear as PrivilegesActionTypes.Clear
});

export type PrivilegesAction = ReturnType<typeof setPrivileges | typeof clearPrivileges>